import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { formatDateToThai } from "../../../../../utils/date.utils";
import { thaiMonths } from "../../../../../utils/monthThai";

const Form07 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  const addressTypeName = "ที่อยู่ที่ทำงาน";

  const {
    day: quit_day,
    month: quit_month,
    year: quit_year,
  } = formatDateToThai(
    dataReportDetail ? dataReportDetail?.main?.quit_date : null
  );

  const {
    day: work_day,
    month: work_month,
    year: work_year,
  } = formatDateToThai(dataEmployee ? dataEmployee?.date_start_work : null);

  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={77}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"ฉายา"}
          end_label={null}
          length={77}
          value={dataEmployee?.buddhist_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"นามสกุล"}
          end_label={null}
          length={80}
          value={dataEmployee?.last_name}
          isParagraph={false}
        />
      </div>

      {/* line 2 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={108}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เลขที"}
          end_label={null}
          length={40}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={105}
          value={"IBSC"}
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"แผนงาน"}
          end_label={"เลี่มปฎิบัติงาร"}
          length={99}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
        {/*  */}
        <span className="ml-4">
          <RenderValue
            start_label={"ตั้งแต่วันที"}
            end_label={null}
            length={30}
            value={work_day}
            isParagraph={false}
          />
        </span>
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={work_month?.toString() ? thaiMonths[work_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={30}
          value={work_year}
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ที่อยู่"}
          end_label={null}
          length={75}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).address_name
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ถนน"}
          end_label={null}
          length={30}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).road
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ตำบล/แขวง"}
          end_label={null}
          length={60}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).district_sub
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"อำเภอ/เขต"}
          end_label={null}
          length={60}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).district
              : ""
          }
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"จังหวัด"}
          end_label={null}
          length={70}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).province
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"รหัสไปรษณีย์"}
          end_label={null}
          length={50}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).postcode
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"โทร"}
          end_label={null}
          length={125}
          value={dataEmployee?.phone_number ?? "-"}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ขอลาออกตั้งแต่วันที"}
          end_label={null}
          length={40}
          value={quit_day}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={quit_month?.toString() ? thaiMonths[quit_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={"เป็นต้นไป"}
          length={40}
          value={quit_year}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เหตุผลในการลาออก"}
          end_label={null}
          length={235}
          value={dataReportDetail?.condition?.reason_quit}
          isParagraph={true}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={null}
          end_label={null}
          length={300}
          value={null}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={
            "จึงเรียน/นมัสการมาเพื่อโปรดพิจารณาอนุมัติ ที่งนี้ได้มอบบัตประจำตัวเจ้าหน้าที่ เลขที"
          }
          end_label={null}
          length={94}
          value={dataEmployee?.employee_no}
          isParagraph={true}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ที่มหาวิทะยาลัยออกให้ข้าพเจ้าคืนพร้อมนี้แล้ว."}
          end_label={null}
          length={0}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* signature*/}
      <div className="w-full flex justify-center mt-24">
        {/*  */}
        <RenderValue
          start_label={"ลงชื่อ"}
          end_label={null}
          length={100}
          value={null}
          isParagraph={false}
          grow={false}
        />
      </div>

      <div className="w-full mt-12">
        <CommentPrint
          title={"ความคิดเห็นของหัวหน้าส่วนงาน"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={4}
          isParagraph={true}
          data={{
            isApprove: data.leave_status === "approve third" ? true : false,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={300}
        />
        <div className="ml-48 mt-24">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <div className="page-break"></div>

        <div className="a4-page">
          <div className="w-full">
            <CommentPrint
              title={"ความคิดเห็นของรองอธิการบดีฝ่ายบริหาร"}
              isCheckBoxApprove={false}
              sxTitle=""
              amountLine={4}
              isParagraph={true}
              data={{
                isApprove: data.leave_status === "approve third" ? true : false,
                comment: data.leave_approve_first_comment ?? "",
              }}
              lengthDot={300}
            />
            <div className="ml-48">
              <SignaturePrint
                title={""}
                prefix={`(ลงชื่อ)`}
                position={""}
                isDate={true}
                isPosition={true}
                data={{}}
              />
            </div>
          </div>

          <div className="w-full">
            <CommentPrint
              title={"คำสั่งของอธิการบดี"}
              isCheckBoxApprove={false}
              sxTitle=""
              amountLine={4}
              isParagraph={true}
              data={{
                isApprove: data.leave_status === "approve third" ? true : false,
                comment: data.leave_approve_first_comment ?? "",
              }}
              lengthDot={300}
            />
            <div className="ml-48">
              <SignaturePrint
                title={""}
                prefix={`(ลงชื่อ)`}
                position={""}
                isDate={true}
                isPosition={true}
                data={{}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form07;
